import React from 'react';
import { useLocation } from 'react-router-dom';

/* ---------- FIELD COMPONENT ---------- */
const Field = ({ label, value }) => (
  <div className="grid grid-cols-12 py-1 text-sm">
    <div className="col-span-4 text-gray-600">{label}</div>
    <div className="col-span-8 font-medium text-gray-900">{value || '-'}</div>
  </div>
);

/* ---------- SECTION COMPONENT ---------- */
const Section = ({ title, children }) => (
  <div className="mb-8">
    <div className="flex items-center gap-3 mb-3">
      <div className="flex-1 h-px bg-gray-300" />
      <h3 className="text-xs font-semibold tracking-widest uppercase text-gray-700">{title}</h3>
      <div className="flex-1 h-px bg-gray-300" />
    </div>
    <div className="space-y-1">{children}</div>
  </div>
);

/* ---------- IMAGE COMPONENT ---------- */
const ImageFrame = ({ label, src }) => (
  <div className="mb-6">
    <p className="text-xs text-gray-500 mb-1">{label}</p>
    <div className="border border-gray-300 h-36 bg-white">
      {src ? (
        <img src={src} alt={label} className="w-full h-full object-cover" />
      ) : (
        <div className="flex items-center justify-center h-full text-gray-400 text-xs">Not Available</div>
      )}
    </div>
  </div>
);

/* ---------- MAIN COMPONENT ---------- */
const GeneralSponsorshipDetails = () => {
  const location = useLocation();
  const data = location.state;

  if (!data) {
    return <div className="flex justify-center items-center min-h-screen text-gray-500">No data found. Please open from list page.</div>;
  }

  const d = data;

  const formatDate = (date) => {
    if (!date) return '-';
    const dt = new Date(date);
    const day = String(dt.getDate()).padStart(2, '0');
    const month = String(dt.getMonth() + 1).padStart(2, '0');
    const year = dt.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="min-h-screen py-8">
      <div className="max-w-6xl mx-auto bg-white border border-gray-300 shadow-sm">
        {/* HEADER */}
        <div className="border-b border-gray-300 px-8 py-5">
          <h1 className="text-center font-semibold text-lg">GENERAL SPONSORSHIP APPLICATION</h1>
          <div className="flex justify-between text-xs text-gray-600 mt-2">
            <span>
              Application ID : <strong className="ml-1">{d._id}</strong>
            </span>
            <span>{formatDate(d.createdAt)}</span>
          </div>
        </div>

        {/* BODY */}
        <div className="grid grid-cols-12 gap-6 px-8 py-8">
          {/* LEFT SIDE */}
          <div className="col-span-9">
            {/* PERSONAL DETAILS */}
            <Section title="Personal Information">
              <Field label="First Name" value={d.name} />
              <Field label="Middle Name" value={d.middleName} />
              <Field label="Last Name" value={d.lastName} />
              <Field label="Email" value={d.email} />
              <Field label="Date Of Birth" value={d.dateOfBirth} />
              <Field label="Place Of Birth" value={d.placeOfBirth} />
              <Field label="Nationality" value={d.nationality} />
              <Field label="Gender" value={d.sex} />
              <Field label="Marital Status" value={d.maritalStatus} />
              <Field label="Blood Group" value={d.bloodGroup} />
              <Field label="Height (cm)" value={d.height} />
              <Field label="Weight (kg)" value={d.weight} />
            </Section>


            
            <Section title="Contact Information">
              <Field label="Mobile Number" value={d.contactNumber} />
              <Field label="Alternate Number" value={d.alternateContactNumber} />
              <Field label="Email Address" value={d.email} />
            </Section>

            {/* ADDRESS */}
            <Section title="Address">
              <Field label="City" value={d.city} />
              <Field label="State" value={d.state} />
              <Field label="Pincode" value={d.pincode} />
            </Section>

            {/* PASSPORT */}
            <Section title="Passport Details">
              <Field label="Passport Number" value={d.passportNo} />
              <Field label="Place Of Issue" value={d.PassportplaceOfIssue} />
              <Field label="Date Of Issue" value={d.PassportdateOfIssue} />
              <Field label="Date Of Expiry" value={d.PassportdateOfExpiry} />
            </Section>

            {/* INDOS */}
            <Section title="INDOS Details">
              <Field label="INDOS Number" value={d.indosNo} />
            </Section>

            {/* PRE-SEA COURSE */}
            <Section title="Pre Sea Course">
              <Field label="Institute Name" value={d.preSeaInstituteName} />
              <Field label="Course Name" value={d.preSeaCourseName} />
            </Section>

            {/* EDUCATION */}
            <Section title="Education Details">
              <Field label="10th School" value={d.school10th} />
              <Field label="Board / University" value={d.exam10th?.boardUniversity} />
              <Field label="Year Of Passing" value={d.exam10th?.yearOfPassing} />
              <Field label="Percentage" value={d.exam10th?.percentage} />
               <Field label="English Marks" value={d.exam10th?.englishMarks} />

              <br />

              <Field label="12th School" value={d.school12th} />
              <Field label="Board / University" value={d.exam12th?.boardUniversity} />
              <Field label="Year Of Passing" value={d.exam12th?.yearOfPassing} />
              <Field label="Percentage" value={d.exam12th?.percentage} />
 <Field label="English Marks" value={d.exam12th?.englishMarks} />
              <br />

              <Field label="College / Institute" value={d.collegeInstitute} />
              <Field label="Board / University" value={d.diplomaDegree?.boardUniversity} />
              <Field label="Year Of Passing" value={d.diplomaDegree?.yearOfPassing} />
              <Field label="Percentage" value={d.diplomaDegree?.percentage} />
               <Field label="English Marks" value={d.diplomaDegree?.englishMarks} />
            </Section>

            <Section title="Family Information">
              <div className="grid grid-cols-4 gap-x-8 text-sm font-medium text-gray-700 mb-6">
                {/* Father Labels */}
                <div className="text-left pr-4">Father First Name</div>
                <div className="font-semibold text-gray-900">{d.fatherFirstName || '-'}</div>

                {/* Mother Labels */}
                <div className="text-left pr-4">Mother First Name</div>
                <div className="font-semibold text-gray-900">{d.motherFirstName || '-'}</div>

                {/* Father Middle Name */}
                <div className="text-left pr-4">Middle Name</div>
                <div className="font-semibold text-gray-900">{d.fatherMiddleName || '-'}</div>

                {/* Mother Middle Name */}
                <div className="text-left pr-4">Middle Name</div>
                <div className="font-semibold text-gray-900">{d.motherMiddleName || '-'}</div>

                {/* Father Last Name */}
                <div className="text-left pr-4">Last Name</div>
                <div className="font-semibold text-gray-900">{d.fatherLastName || '-'}</div>

                {/* Mother Last Name */}
                <div className="text-left pr-4">Last Name</div>
                <div className="font-semibold text-gray-900">{d.motherLastName || '-'}</div>
              </div>

            
            </Section>

            {/* OTHER DETAILS */}
            <Section title="Other Details">
              <Field label="Reference Source" value={d.referenceSource} />
            </Section>
          </div>

          {/* RIGHT SIDE IMAGES */}
          <div className="col-span-3">
            <div className="border border-gray-300 bg-gray-50 p-3 sticky top-6">
              <ImageFrame label="Passport Photo" src={d.passportPhoto} />
              <ImageFrame label="Photo ID Proof" src={d.photoIdProof} />
              <ImageFrame label="Address Proof" src={d.addressProof} />
              <ImageFrame label="10th Marksheet" src={d.markSheet10} />
              <ImageFrame label="12th Marksheet" src={d.markSheet12} />
              <ImageFrame label="Degree Certificate" src={d.degree} />
              <ImageFrame label="Admission Letter" src={d.admissionLetterCopy} />
              <ImageFrame label="Pre Sea Certificate" src={d.preSeaCertificateCopy} />
              <ImageFrame label="STCW Certificate" src={d.stcwCertificateCopy} />
              <ImageFrame label="Medical Certificate" src={d.medicalCertificateCopy} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralSponsorshipDetails;
